import React from 'react';

import { BannerViewType } from '../../typings/pcode';
import { CreativePreview } from '../CreativePreview/CreativePreview';

export class Html5CreativePreview extends React.PureComponent<{
    previewUrl: string;
    cspNonce: string;
    width?: number;
    height?: number;
}> {
    render() {
        const { previewUrl, cspNonce, width, height } = this.props;
        const matchResult = previewUrl && previewUrl.match(/\/html5\/(?:([a-f0-9]+)\/)?(\d+)\/preview/i);
        if (!matchResult) {
            return null;
        }

        const batchId = matchResult[1] || '';
        const creativeId = matchResult[2];

        return (
            <CreativePreview
                creativeId={creativeId}
                batchId={batchId}
                width={width}
                height={height}
                previewType={BannerViewType.html5CreativePreview}
                isSquareFormat={false}
                cspNonce={cspNonce}
            />
        );
    }
}
